import { Button, HStack, Text } from 'native-base'
import { useTranslation } from 'react-i18next'

export interface ResendCodeProps {
  resendAuth: () => void
  resendLoading: boolean
  disableSubmit: boolean
  disableResend: boolean
}

export const ResendCode = ({ resendAuth, resendLoading, disableSubmit, disableResend }: ResendCodeProps) => {
  const { t } = useTranslation()
  return (
    <HStack justifyContent={'center'} alignItems={'center'}>
      <Text fontSize={14} color={'gray.500'} textAlign={'center'}>
        Didn't receive a verification code?
      </Text>
      <Button
        onPress={resendAuth}
        isDisabled={disableResend || disableSubmit}
        isLoading={resendLoading}
        variant={'link'}
        ml={-2}
        py={0}
      >
        <Text fontSize={14} color={'gray.600'} fontWeight={'bold'} textDecorationLine={'underline'}>
          {t('common:RESEND')}
        </Text>
      </Button>
    </HStack>
  )
}
